import AddInternalUser from './AddInternalUser';
import { connect } from 'react-redux';
import { RootState } from 'Store/Reducers/RootReducer';
import * as UserModule from 'Modules/UserModule';
import { Actions as GroupActions, Selectors as GroupSelectors } from 'Modules/GroupModule';
import { Selectors as ViewManagementSelectors } from 'Modules/ViewManagementModule';

type ConnectedP = {
  prevPath: string;
  group: Array<any>;
};
type DispatchedP = {
  addInternalUser: (data: any) => void;
  getGroup: () => void;
};

export type MainType = ConnectedP & DispatchedP;

const mapDispatchToProps: DispatchedP = {
  addInternalUser: (data: any) => UserModule.Actions.addInternalUser(data),
  getGroup: () => GroupActions.getGroup(),
};

function mapStateToProps(state: RootState): ConnectedP {
  return {
    prevPath: ViewManagementSelectors.prevPath(state),
    group: GroupSelectors.getGroupData(state),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddInternalUser);
